// src/components/dashboard/cases/newCase/case_id/caseTable/components/FilesPanel.js
import React from "react";
import { OPACITY_MIN, OPACITY_MAX } from "../constants";
import { getFileLabel } from "../utils/geometry";

const FilesPanel = ({
  fileUrls,
  filesPanelOpen,
  setFilesPanelOpen,
  showAllModels,
  getModelState,
  updateModelState,
  linkable,
  toggleModelDetached,
}) => {
  return (
    <div
      className="stl-files-panel"
      role="group"
      aria-label="Model visibility and opacity"
      onContextMenu={(e) => e.preventDefault()}
    >
      <div className="stl-files-head">
        <span className="stl-files-title">Models ({fileUrls.length})</span>
        <div className="stl-files-head-actions">
          <button
            type="button"
            className="stl-files-mini"
            onClick={showAllModels}
            title="Show all models"
          >
            Show all
          </button>
          <button
            type="button"
            className="stl-files-mini stl-files-collapse"
            onClick={() => setFilesPanelOpen((v) => !v)}
            aria-expanded={filesPanelOpen}
            title={filesPanelOpen ? "Collapse" : "Expand"}
          >
            {filesPanelOpen ? "−" : "+"}
          </button>
        </div>
      </div>

      {filesPanelOpen && (
        <div className="stl-files-list">
          {fileUrls.map((item, i) => {
            const st = getModelState(i);
            const label = getFileLabel(item, i);
            const fill =
              ((st.opacity - OPACITY_MIN) / (OPACITY_MAX - OPACITY_MIN)) * 100 + "%";
            return (
              <div
                key={i + "|" + label}
                className={"stl-files-row" + (st.visible ? "" : " is-hidden")}
              >
                <button
                  type="button"
                  className={"stl-files-eye" + (st.visible ? " on" : "")}
                  onClick={() => updateModelState(i, { visible: !st.visible })}
                  title={st.visible ? "Hide model" : "Show model"}
                  aria-label={(st.visible ? "Hide " : "Show ") + label}
                  aria-pressed={st.visible}
                >
                  {st.visible ? (
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M1 12s4-7 11-7 11 7 11 7-4 7-11 7S1 12 1 12z" />
                      <circle cx="12" cy="12" r="3" />
                    </svg>
                  ) : (
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M17.94 17.94A10.94 10.94 0 0 1 12 19c-7 0-11-7-11-7a19.8 19.8 0 0 1 5.06-5.94" />
                      <path d="M9.9 4.24A10.9 10.9 0 0 1 12 5c7 0 11 7 11 7a19.7 19.7 0 0 1-3.17 4.19" />
                      <path d="M14.12 14.12a3 3 0 1 1-4.24-4.24" />
                      <path d="M1 1l22 22" />
                    </svg>
                  )}
                </button>

                <div className="stl-files-body">
                  <div className="stl-files-line">
                    <span className="stl-files-name" title={label}>{label}</span>
                    <span className="stl-files-value">{st.opacity}%</span>
                  </div>
                  <input
                    type="range"
                    className="stl-opacity-slider stl-files-slider"
                    min={OPACITY_MIN}
                    max={OPACITY_MAX}
                    step={1}
                    value={st.opacity}
                    disabled={!st.visible}
                    onChange={(e) =>
                      updateModelState(i, { opacity: Number(e.target.value) })
                    }
                    aria-label={"Opacity of " + label}
                    style={{ "--stl-opacity-fill": fill }}
                  />
                </div>

                {linkable[i] && (
                  <button
                    type="button"
                    className={"stl-files-link" + (st.detached ? "" : " on")}
                    onClick={() => toggleModelDetached(i)}
                    title={
                      st.detached
                        ? "Detached — click to connect back to the group"
                        : "Connected — click to detach to the side"
                    }
                    aria-label={(st.detached ? "Connect " : "Detach ") + label}
                    aria-pressed={!st.detached}
                  >
                    {st.detached ? (
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M18.84 12.25l1.72-1.71a5 5 0 0 0-7.07-7.07l-1.72 1.71" />
                        <path d="M5.17 11.75l-1.71 1.71a5 5 0 0 0 7.07 7.07l1.71-1.71" />
                        <line x1="8" y1="2" x2="8" y2="5" />
                        <line x1="2" y1="8" x2="5" y2="8" />
                        <line x1="16" y1="19" x2="16" y2="22" />
                        <line x1="19" y1="16" x2="22" y2="16" />
                      </svg>
                    ) : (
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71" />
                        <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71" />
                      </svg>
                    )}
                  </button>
                )}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default FilesPanel;